import { baseTheme } from './baseTheme'

export const themeByCSSVariables = {
  typography: {
    // если использовать переменные не подставляются значения
    ...baseTheme.typography,
    family: {
      MTSWide: 'var(--typography-family-MTSWide)',
      MTSCompact: 'var(--typography-family-MTSCompact)',
    },
  },
  colors: {
    text: {
      accent: 'var(--colors-text-accent)',
      primary: 'var(--colors-text-primary)',
      secondary: 'var(--colors-text-secondary)',
      tertiary: 'var(--colors-text-tertiary)',
      inverted: 'var(--colors-text-inverted)',
      positive: 'var(--colors-text-positive)',
      negative: 'var(--colors-text-negative)',
      primaryLink: 'var(--colors-text-primaryLink)',
      visitedLink: 'var(--colors-text-visitedLink)',
      secondaryLink: 'var(--colors-text-secondaryLink)',
      visitedSecondaryLink: 'var(--colors-text-visitedSecondaryLink)',
      warning: 'var(--colors-text-warning)',
      disabled: 'var(--colors-text-disabled)',
    },

    background: {
      primary: 'var(--colors-background-primary)',
      modal: 'var(--colors-background-modal)',
      secondary: 'var(--colors-background-secondary)',
      inverted: 'var(--colors-background-inverted)',
      hover: 'var(--colors-background-hover)',
      header: 'var(--colors-background-header)',
      disabled: 'var(--colors-background-disabled)',
      accent: 'var(--colors-background-accent)',
      accent_30: 'var(--colors-background-accent_30)',
      tertiary: 'var(--colors-background-tertiary)',
      elevated: 'var(--colors-background-elevated)',
      warning: 'var(--colors-background-warning)',
      positive: 'var(--colors-background-positive)',
      gradientAccent: 'var(--colors-background-gradientAccent)',
      gradientSecondary: 'var(--colors-background-gradientSecondary)',
    },

    icon: {
      primary: 'var(--colors-icon-primary)',
      secondary: 'var(--colors-icon-secondary)',
      tertiary: 'var(--colors-icon-tertiary)',
      inverted: 'var(--colors-icon-inverted)',
      accent: 'var(--colors-icon-accent)',
      positive: 'var(--colors-icon-positive)',
      negative: 'var(--colors-icon-negative)',
      warning: 'var(--colors-icon-warning)',
      disabled: 'var(--colors-icon-disabled)',
    },

    badge: {
      sale: 'var(--colors-badge-sale)',
      new: 'var(--colors-badge-new)',
      popular: 'var(--colors-badge-popular)',
      waiting: 'var(--colors-badge-waiting)',
      popular_20: 'var(--colors-badge-popular_20)',
      official: 'var(--colors-badge-official)',
      official_20: 'var(--colors-badge-official_20)',
      sale_20: 'var(--colors-badge-sale_20)',
      new_20: 'var(--colors-badge-new_20)',
      negative: 'var(--colors-badge-negative)',
      negative_20: 'var(--colors-badge-negative_20)',
      positive: 'var(--colors-badge-positive)',
      positive_20: 'var(--colors-badge-positive_20)',
      warning: 'var(--colors-badge-warning)',
      warning_20: 'var(--colors-badge-warning_20)',
    },

    stroke: {
      default: 'var(--colors-stroke-default)',
      hover: 'var(--colors-stroke-hover)',
      active: 'var(--colors-stroke-active)',
      error: 'var(--colors-stroke-error)',
      alternativeActive: 'var(--colors-stroke-alternativeActive)',
      positive: 'var(--colors-stroke-positive)',
    },

    overlay: {
      primary: 'var(--colors-overlay-primary)',
      primary_65: 'var(--colors-overlay-primary_65)',
    },

    toast: {
      success: {
        background: 'var(--colors-toast-success-background)',
        icon: 'var(--colors-toast-success-icon)',
      },
      error: {
        background: 'var(--colors-toast-error-background)',
        icon: 'var(--colors-toast-error-icon)',
      },
      warning: {
        background: 'var(--colors-toast-warning-background)',
        icon: 'var(--colors-toast-warning-icon)',
      },
      info: {
        background: 'var(--colors-toast-info-background)',
        icon: 'var(--colors-toast-info-icon)',
      },
    },

    constant: {
      white: 'var(--colors-constant-white)',
      white_5: 'var(--colors-constant-white_5)',
      white_10: 'var(--colors-constant-white_10)',
      white_65: 'var(--colors-constant-white_65)',
      black: 'var(--colors-constant-black)',
      gray: 'var(--colors-constant-gray)',
    },
  },
}
